// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"5a988b23","52":"77cb76a2","119":"909e1128","138":"f9953a04","159":"ea4f6cb7","452":"bc039bc4","549":"f549d9d1","560":"9e573a7b","699":"168b8d95","728":"be09c123","825":"70c6ed6c"}[chunkId] + ".chunk.js";
};